import type { PlanFormState } from '../types';

export function emptyPlanForm(): PlanFormState {
  return {
    name: '',
    description: '',
    interval: 'month',
    maxUsers: '',
    maxWhatsappConnections: '1',
    storageMB: '',
  };
}

export function generatePlanSlug(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function buildPlanLimits(form: PlanFormState): Record<string, number> | undefined {
  const limits: Record<string, number> = {};
  const included = Number(form.maxWhatsappConnections);
  if (!form.maxWhatsappConnections.trim() || !Number.isInteger(included) || included < 0 || included > 100000) {
    throw new Error('Informe entre 0 e 100.000 canais incluídos.');
  }
  limits.whatsapp_connections = included;
  const storageMB = form.storageMB ? parseInt(form.storageMB, 10) : NaN;
  if (Number.isFinite(storageMB) && storageMB > 0) limits.storage_mb = storageMB;
  return Object.keys(limits).length ? limits : undefined;
}
